export default __webpack_public_path__ + "static/media/gp-img.71c5289e.png";